export interface CategoryItem {
  slug: string;
  name: string;
  icon: string;
  desc: string;
  accent: "primary" | "accent" | "secondary";
}

export interface ArticleItem {
  id: number;
  title: string;
  excerpt: string;
  content: string[];
  categorySlug: string;
  categoryName: string;
  author: string;
  time: string;
  date: string;
  readTime: string;
  tags: string[];
  image: string;
  imageAlt: string;
  comments: number;
  heat: number;
  isTop: boolean;
  isBreaking: boolean;
}

export const siteName = "沸点爆料";
export const siteSlogan = "追踪刚刚发生的事";
export const siteDesc = "热点爆料今日快讯频道，实时追踪刚刚发生的热门事件，汇总热点爆料最新动态，持续更新不遗漏。";

export const categories: CategoryItem[] = [
  {
    slug: "yule",
    name: "娱乐爆料",
    icon: "ri-mic-line",
    desc: "剧集综艺、演出票务与片场动态，第一时间跟进娱乐热点。",
    accent: "primary",
  },
  {
    slug: "shehui",
    name: "社会热点",
    icon: "ri-earth-line",
    desc: "城市生活、公共政策与民生现场，关注正在发生的身边事。",
    accent: "accent",
  },
  {
    slug: "keji",
    name: "科技快讯",
    icon: "ri-cpu-line",
    desc: "新品发布、行业开源与产品更新，追踪科技圈最新动向。",
    accent: "secondary",
  },
  {
    slug: "shenghuo",
    name: "生活八卦",
    icon: "ri-cup-line",
    desc: "吃喝玩乐、消费新习惯与市井观察，聊聊身边的小趋势。",
    accent: "primary",
  },
  {
    slug: "tiyu",
    name: "体坛动态",
    icon: "ri-basketball-line",
    desc: "赛事战报、青训观察与场馆故事，赛场内外一网打尽。",
    accent: "accent",
  },
  {
    slug: "caijing",
    name: "财经观察",
    icon: "ri-line-chart-line",
    desc: "小店经济、县域消费与产业变化，读懂身边的生意经。",
    accent: "secondary",
  },
];

export const articles: ArticleItem[] = [
  {
    id: 1,
    title: "古装剧《长夜行》收官夜热搜霸榜，主创回应加更争议",
    excerpt:
      "开播四十二天，《长夜行》迎来收官。收官当晚相关话题连登多个热搜，观众一边催第二季，一边对结局节奏提出疑问，主创团队深夜发文回应。",
    content: [
      "这部从开播就争议不断的古装剧，昨晚迎来了收官夜。剧集上线后不久，多个与剧情相关的话题先后登上热搜榜，从人物命运到台词细节，讨论热度持续了整整一个晚上。",
      "观众的反馈呈现明显的两极：一部分观众认为后期节奏过快，几条支线的收束略显仓促；另一部分观众则表示结局的反转设计出乎意料，愿意为其打出高分。围绕「要不要加更」的讨论，也成了当晚最集中的话题之一。",
      "针对加更争议，主创团队在深夜发布长文说明，称后期制作周期紧张，团队连续数周加班赶制特效与配乐，最终选择了保证完成度的排播方式，并向等待的观众致歉。文中还透露，若后续条件允许，会考虑补充番外内容。",
      "一位参与后期的工作人员向本频道表示，类似「边播边做」的排播模式在近年并不少见，它对制作方的时间管理提出了更高要求。至于第二季，出品方目前尚未给出明确时间表。",
    ],
    categorySlug: "yule",
    categoryName: "娱乐爆料",
    author: "爆料组 · 阿森",
    time: "18 分钟前",
    date: "2026-09-10T09:42:00+08:00",
    readTime: "4 分钟",
    tags: ["剧集收官", "热搜", "加更争议"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20about%20a%20costume%20drama%20finale%20and%20trending%20topic%20buzz%2C%20abstract%20geometric%20shapes%2C%20flat%20vector%20style%2C%20warm%20vermillion%20red%20and%20amber%20gold%20on%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20no%20faces&width=1200&height=900&seq=news-fd-01&orientation=landscape",
    imageAlt: "古装剧收官与热搜话题的概念插画",
    comments: 1286,
    heat: 9860,
    isTop: true,
    isBreaking: true,
  },
  {
    id: 2,
    title: "音乐节门票开票秒空，二手平台加价转卖引热议",
    excerpt:
      "上周末开票的户外音乐节，两分钟内多个价位售罄。随后二手平台上出现大量加价转让信息，主办方表示将启用实名核验与退票回流机制。",
    content: [
      "这场定档在十月的户外音乐节，开票时间一到，多个价位的门票在两分钟内显示售罄。社交平台上，不少乐迷晒出了排队页面卡顿的截图。",
      "开票后不到半小时，二手交易平台就出现了大量转让信息，部分位置较好的场次加价幅度超过票面价格的两倍。有卖家声称「手上有渠道」，但无法提供明确的验票方式。",
      "主办方随后发布公告，表示将对入场证件进行实名核验，并启动退票回流通道，把退票重新放回官方渠道销售。公告同时提醒观众，通过非官方渠道购票存在无法入场和无法退改的风险。",
      "有票务行业从业者分析，热门演出的供需矛盾短期内难以彻底缓解，「实名制 + 动态回流」是目前较为务实的做法，但执行效果取决于现场核验的严格程度。",
    ],
    categorySlug: "yule",
    categoryName: "娱乐爆料",
    author: "快讯编辑 · 林小满",
    time: "46 分钟前",
    date: "2026-09-10T09:14:00+08:00",
    readTime: "3 分钟",
    tags: ["音乐节", "票务", "二手转卖"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20about%20concert%20tickets%20selling%20out%20and%20resale%20market%2C%20abstract%20geometric%20shapes%2C%20flat%20vector%20style%2C%20warm%20vermillion%20red%20and%20amber%20gold%20on%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20no%20faces&width=1200&height=900&seq=news-fd-02&orientation=landscape",
    imageAlt: "演唱会门票售罄与二级市场转卖的概念插画",
    comments: 642,
    heat: 7320,
    isTop: false,
    isBreaking: false,
  },
  {
    id: 3,
    title: "暴雨夜外卖订单激增，平台宣布超时订单当日免罚",
    excerpt:
      "昨夜多地强降雨，外卖订单量明显上涨。平台方面表示，因天气导致的超时订单将统一免除骑手处罚，并延长了部分区域的配送时长。",
    content: [
      "昨晚的强降雨让不少人的晚饭变成了外卖。多个外卖平台的后台数据显示，雨势最大的两个小时里，生鲜与热食订单量比平日同期上涨了三成以上。",
      "订单暴涨的同时，配送时长被拉长。有用户在社交平台晒出订单页面，显示预计送达时间比平时多了二十多分钟。也有骑手在群里表示，涉水路段较多，骑行速度不得不放慢。",
      "当天深夜，平台发布公告称，因恶劣天气导致的超时、取消等异常订单，将统一免除对骑手的处罚，同时对受影响的用户发放配送体验补偿。公告还提到，已在重点区域增加了临时调度人手。",
      "有城市管理研究者指出，极端天气下的劳动保障需要平台、商家与用户共同分担，「把天气造成的损耗从最末端骑手身上移开」是更合理的处理方向。",
    ],
    categorySlug: "shehui",
    categoryName: "社会热点",
    author: "现场组 · 陈默",
    time: "1 小时前",
    date: "2026-09-10T08:55:00+08:00",
    readTime: "4 分钟",
    tags: ["暴雨", "外卖", "劳动保障"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20about%20a%20rainy%20night%20with%20surging%20food%20delivery%20orders%2C%20abstract%20geometric%20shapes%2C%20flat%20vector%20style%2C%20warm%20vermillion%20red%20and%20amber%20gold%20on%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20no%20faces&width=1200&height=900&seq=news-fd-03&orientation=landscape",
    imageAlt: "雨夜外卖订单激增的概念插画",
    comments: 913,
    heat: 8610,
    isTop: true,
    isBreaking: true,
  },
  {
    id: 4,
    title: "地铁车厢手机外放被劝阻，新规落地首周引发讨论",
    excerpt:
      "多地地铁近期明确禁止车厢内电子设备外放声音。新规实施首周，既有乘客主动劝阻，也出现了因沟通方式引发的争论。",
    content: [
      "「请勿在车厢外放声音」的提示牌，最近出现在不少城市的地铁站台与车厢内。新规实施第一周，关于它的讨论就登上了本地话题榜。",
      "支持的乘客认为，早晚高峰本就拥挤，外放短视频和语音通话会加剧环境噪音，明确规则有助于减少摩擦。也有乘客提出，劝阻的边界需要更清晰，避免把善意提醒变成争执。",
      "多个城市的地铁运营方表示，目前以劝导为主，对拒不配合、影响正常秩序的行为，会依据相关规定处理。部分线路还上线了车厢内的静音提示广播，循环播放频次有所提高。",
      "一位通勤族在接受采访时说，规则明确了，大家反而更好沟通，「以前开口会担心显得多事，现在有依据了，说一句也更自然」。",
    ],
    categorySlug: "shehui",
    categoryName: "社会热点",
    author: "快讯编辑 · 周迟",
    time: "2 小时前",
    date: "2026-09-10T07:48:00+08:00",
    readTime: "3 分钟",
    tags: ["地铁新规", "公共秩序", "通勤"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20about%20a%20quiet%20subway%20carriage%20rule%20and%20polite%20reminder%2C%20abstract%20geometric%20shapes%2C%20flat%20vector%20style%2C%20warm%20vermillion%20red%20and%20amber%20gold%20on%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20no%20faces&width=1200&height=900&seq=news-fd-04&orientation=landscape",
    imageAlt: "地铁静音新规与车厢秩序的概念插画",
    comments: 507,
    heat: 6240,
    isTop: false,
    isBreaking: false,
  },
  {
    id: 5,
    title: "国产大模型再度开源，开发者社区连夜跟进微调",
    excerpt:
      "一款支持长上下文的开源大模型昨日发布权重，多个开发者社区在数小时内上线了推理与微调脚本，讨论集中在部署成本与中文表现。",
    content: [
      "昨天下午，一个主打长上下文处理的开源大模型放出了模型权重与推理代码。发布会结束后不久，国内多个开发者社区就出现了第一批部署教程。",
      "有开发者在当天深夜完成本地微调，并在社区分享了显存占用与推理速度的实测数据。讨论的焦点集中在两点：一是消费级显卡能否跑动，二是中文长文本任务的实际表现。",
      "一位参与适配的工程师向本频道表示，这次开源的一个亮点是推理框架适配做得比较完整，降低了上手门槛，「过去要折腾一两天，现在半天能跑通」。",
      "随着开源模型迭代加快，行业关注点正从「能不能用」转向「在具体场景里省不省钱」。有团队已经把它接入客服知识库的检索环节，用来压缩响应时间。",
    ],
    categorySlug: "keji",
    categoryName: "科技快讯",
    author: "科技组 · 顾言",
    time: "2 小时前",
    date: "2026-09-10T07:30:00+08:00",
    readTime: "4 分钟",
    tags: ["开源模型", "长上下文", "开发者"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20about%20an%20open%20source%20language%20model%20release%20and%20developer%20community%2C%20abstract%20geometric%20shapes%2C%20flat%20vector%20style%2C%20warm%20vermillion%20red%20and%20amber%20gold%20on%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20no%20faces&width=1200&height=900&seq=news-fd-05&orientation=landscape",
    imageAlt: "开源大模型发布与开发者讨论的概念插画",
    comments: 384,
    heat: 7010,
    isTop: false,
    isBreaking: false,
  },
  {
    id: 6,
    title: "折叠屏手机销量同比翻番，轻薄化成新战场",
    excerpt:
      "多家调研机构的数据显示，折叠屏手机上半年出货量同比接近翻番。厂商的竞争重点，正从「折得起来」转向「折起来也够薄」。",
    content: [
      "最新公布的行业数据显示，折叠屏手机上半年的出货量同比接近翻番，在整体手机市场增长放缓的背景下显得格外突出。",
      "与早期产品相比，这一代折叠屏最明显的变化是厚度与重量。多家厂商在发布会上反复强调「合起来和直板机差不多」，铰链结构和水滴屏方案成为主要卖点。",
      "价格下探同样是销量增长的重要推手。部分竖折机型的起售价已经进入中端价位，吸引了一批原本只考虑直板机的用户。有线下门店店员表示，最近来体验折叠屏的顾客明显变多，其中不少是给家人挑选。",
      "不过也有用户提出顾虑，主要集中在屏幕耐用性与维修成本。业内人士认为，折叠屏要真正走向主流，除了做薄，售后体系和使用寿命的证明同样关键。",
    ],
    categorySlug: "keji",
    categoryName: "科技快讯",
    author: "科技组 · 孟舟",
    time: "3 小时前",
    date: "2026-09-10T06:52:00+08:00",
    readTime: "3 分钟",
    tags: ["折叠屏", "手机市场", "轻薄化"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20about%20slim%20foldable%20smartphones%20and%20a%20competitive%20market%2C%20abstract%20geometric%20shapes%2C%20flat%20vector%20style%2C%20warm%20vermillion%20red%20and%20amber%20gold%20on%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20no%20faces&width=1200&height=900&seq=news-fd-06&orientation=landscape",
    imageAlt: "轻薄折叠屏手机市场竞争的概念插画",
    comments: 268,
    heat: 5480,
    isTop: false,
    isBreaking: false,
  },
  {
    id: 7,
    title: "露营热度降温？商家集体转做城市短途微度假",
    excerpt:
      "曾经一位难求的露营基地，如今预订变得从容。不少经营者把重心转向城市周边的短途微度假，用「轻装备 + 好餐饮」重新吸引客人。",
    content: [
      "两年前还要提前一个月抢的露营地，如今在周末也能临时订到位置。一位经营者在采访中坦言，单纯靠帐篷和天幕的模式，复购率确实在下滑。",
      "变化随之而来。越来越多的营地开始提供「一价全包」的轻装备套餐，把折叠椅、烤炉提前摆好，客人只需要带上自己和食材。餐饮档次被明显提升，有的营地和本地餐厅合作，推出半成品烧烤套餐。",
      "在社交平台上，「城市周边微度假」的搜索量稳步上升。关键词从「硬核露营」变成了「不用收拾」「带娃友好」「两小时车程」。",
      "业内人士认为，这轮调整说明消费者从追逐新鲜感，转向更看重出行成本和体验确定性。能不能把「省事」做到位，可能决定下一批营地的存活。",
    ],
    categorySlug: "shenghuo",
    categoryName: "生活八卦",
    author: "生活组 · 苏晓",
    time: "4 小时前",
    date: "2026-09-10T06:05:00+08:00",
    readTime: "3 分钟",
    tags: ["露营", "微度假", "周末经济"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20about%20a%20relaxed%20city%20weekend%20micro%20vacation%20camping%20setup%2C%20abstract%20geometric%20shapes%2C%20flat%20vector%20style%2C%20warm%20vermillion%20red%20and%20amber%20gold%20on%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20no%20faces&width=1200&height=900&seq=news-fd-07&orientation=landscape",
    imageAlt: "城市周边微度假露营场景的概念插画",
    comments: 431,
    heat: 5960,
    isTop: false,
    isBreaking: false,
  },
  {
    id: 8,
    title: "年轻人爱上「剩菜盲盒」，晚上八点后超市排起长队",
    excerpt:
      "临近打烊，超市和面包店把当天未能售罄的食品打包成盲盒低价出售。有人算过账，一顿晚饭只要十几块，也有人把它当成一次「开盲盒」的乐趣。",
    content: [
      "晚上八点刚过，一家社区面包店的柜台前已经排起了队。货架上剩下的可颂、贝果和吐司被装进统一纸袋，按固定价格出售，买的人看不到具体内容。",
      "这种被网友称作「剩菜盲盒」的消费方式，最近在年轻人中流行起来。有人看中的是价格，十几块钱就能解决一顿晚饭；也有人坦言，拆袋那一刻的未知感本身就很有意思。",
      "对商家而言，这既减少了临期食品的浪费，也带来了打烊前的一波客流。有店主表示，原本要处理掉的库存现在基本能清空，损耗率明显下降。",
      "需要注意的是，购买时要留意包装上的生产与保质信息，尽量当天食用。有营养师提醒，盲盒的便利性不能替代对食品状态的确认，尤其是需要冷藏的品类。",
    ],
    categorySlug: "shenghuo",
    categoryName: "生活八卦",
    author: "生活组 · 陈柚",
    time: "5 小时前",
    date: "2026-09-10T05:20:00+08:00",
    readTime: "3 分钟",
    tags: ["剩菜盲盒", "消费习惯", "食物浪费"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20about%20young%20people%20queuing%20for%20discounted%20surprise%20bakery%20bags%20after%20eight%20pm%2C%20abstract%20geometric%20shapes%2C%20flat%20vector%20style%2C%20warm%20vermillion%20red%20and%20amber%20gold%20on%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20no%20faces&width=1200&height=900&seq=news-fd-08&orientation=landscape",
    imageAlt: "剩菜盲盒排队场景的概念插画",
    comments: 588,
    heat: 6650,
    isTop: false,
    isBreaking: false,
  },
  {
    id: 9,
    title: "联赛争冠悬念保留到最后一轮，黑马球队锁定季后赛",
    excerpt:
      "昨晚结束的一轮比赛后，联赛积分榜前三名的差距缩小到两分。本赛季开局并不被看好的黑马球队，提前一轮锁定了季后赛席位。",
    content: [
      "联赛倒数第二轮结束后，积分榜前三名之间的差距只剩下两分，冠军归属被保留到了最后一轮。昨晚的两场关键比赛，都出现了终场前的进球。",
      "最受关注的是那支赛季初排名靠后的黑马球队。他们在下半程拿到了一波连胜，昨晚客场取胜后，提前一轮锁定了季后赛席位，替补席上的球员冲进场内庆祝。",
      "主教练在赛后发布会上把功劳归给球队的体能储备，认为密集赛程下能否保持跑动，是拉开差距的关键。他也提到，球队的引援策略更看重适配度而非名气。",
      "最后一轮的对阵表已经出炉，三支争冠球队的比赛被安排在同一时间开球。有球迷在社交平台调侃，那天晚上可能要同时盯着三块屏幕。",
    ],
    categorySlug: "tiyu",
    categoryName: "体坛动态",
    author: "体育组 · 郑野",
    time: "6 小时前",
    date: "2026-09-10T04:38:00+08:00",
    readTime: "3 分钟",
    tags: ["联赛", "争冠", "黑马"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20about%20a%20tight%20league%20title%20race%20and%20an%20underdog%20team%2C%20abstract%20geometric%20shapes%2C%20flat%20vector%20style%2C%20warm%20vermillion%20red%20and%20amber%20gold%20on%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20no%20faces&width=1200&height=900&seq=news-fd-09&orientation=landscape",
    imageAlt: "联赛争冠与黑马球队的概念插画",
    comments: 742,
    heat: 6890,
    isTop: false,
    isBreaking: false,
  },
  {
    id: 10,
    title: "青训营报名人数创新高，家长看重的已不只是职业出路",
    excerpt:
      "多家青少年体育培训机构表示，今年暑期报名人数创下近年新高。不少家长坦言，比起走职业道路，更看重孩子体能和团队意识的变化。",
    content: [
      "暑假接近尾声，几家青少年体育培训机构陆续公布了暑期的报名数据，多个项目的人数创下近年新高，其中篮球与游泳的增长尤为明显。",
      "与过去「冲着职业队去」的心态不同，采访中不少家长表示，送孩子来主要是为了锻炼身体和培养规律作息。「能不能踢出来不好说，但每天运动一小时，对他的状态肯定有帮助」。",
      "机构方面也在调整课程结构，增加了体能测评和运动损伤预防的内容。有教练提到，现在家长会主动询问训练强度和恢复安排，这在前几年并不多见。",
      "有体育教育研究者认为，这种观念转变是好事，它让青训从「选拔」逐渐回到「教育」。但同时也提醒，机构需要更透明的资质与安全标准，避免热度之下粗放扩张。",
    ],
    categorySlug: "tiyu",
    categoryName: "体坛动态",
    author: "体育组 · 何川",
    time: "7 小时前",
    date: "2026-09-10T03:50:00+08:00",
    readTime: "3 分钟",
    tags: ["青训", "青少年体育", "暑期"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20about%20children%20joining%20a%20sports%20training%20camp%20in%20summer%2C%20abstract%20geometric%20shapes%2C%20flat%20vector%20style%2C%20warm%20vermillion%20red%20and%20amber%20gold%20on%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20no%20faces&width=1200&height=900&seq=news-fd-10&orientation=landscape",
    imageAlt: "青少年体育训练营的概念插画",
    comments: 356,
    heat: 5120,
    isTop: false,
    isBreaking: false,
  },
  {
    id: 11,
    title: "小店经济回暖，社区餐饮夜间订单增长明显",
    excerpt:
      "一份面向社区小店的抽样数据显示，近期夜间订单量同比上升一成以上。营业时间的延长，正在成为不少社区餐饮的增量来源。",
    content: [
      "一份覆盖多个城市的社区小店抽样数据显示，进入下半年后，社区餐饮的夜间订单量同比上升超过一成，其中面馆、烧烤和小炒类增长最为明显。",
      "变化的原因之一，是营业时间的延长。多家受访店铺把打烊时间从晚上九点推迟到十一点，有的还专门增加了夜宵菜单。店主们普遍反映，下班晚的客群正在扩大。",
      "除了堂食，外卖也在贡献增量。有平台数据显示，社区商圈的深夜订单占比持续走高，配送距离普遍较短，这让小店在没有大幅增加成本的情况下接到了更多单。",
      "不过，延长营业也带来了人力上的压力。有店主表示，正在尝试用错峰排班和半成品备餐来平衡，如何在多赚一点和多休息一点之间找到平衡，是接下来要解决的问题。",
    ],
    categorySlug: "caijing",
    categoryName: "财经观察",
    author: "财经组 · 韦知",
    time: "8 小时前",
    date: "2026-09-10T02:40:00+08:00",
    readTime: "3 分钟",
    tags: ["小店经济", "社区餐饮", "夜经济"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20about%20warm%20neighborhood%20food%20shops%20and%20late%20night%20orders%2C%20abstract%20geometric%20shapes%2C%20flat%20vector%20style%2C%20warm%20vermillion%20red%20and%20amber%20gold%20on%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20no%20faces&width=1200&height=900&seq=news-fd-11&orientation=landscape",
    imageAlt: "社区小店夜间营业回暖的概念插画",
    comments: 297,
    heat: 4760,
    isTop: false,
    isBreaking: false,
  },
  {
    id: 12,
    title: "新能源车下乡提速，县域充电设施成关键一环",
    excerpt:
      "新一轮新能源车下乡活动启动，多家车企推出了面向县域市场的车型。业内普遍认为，充电桩的覆盖密度将直接影响这轮推广的效果。",
    content: [
      "新一轮新能源车下乡活动本周启动，多家车企带来了适配县域市场的车型，价格区间集中在入门段，并在续航与通过性上做了针对性调整。",
      "与城市不同，县域用户的用车场景更分散，通勤距离更长，对补能便利性的要求也更高。有经销商反映，来店里看车的顾客，问得最多的就是「镇上有没有充电桩」。",
      "为此，多地正在加快乡镇层面的充电设施布局，部分加油站和服务区新增了快充车位。有运营方表示，会优先在车流集中的乡镇网点试点，再根据使用率决定扩容节奏。",
      "分析人士指出，下乡不只是把车卖出去，更要让用车体验跟得上。充电网络的密度、售后网点的可达性，都会影响用户口碑和后续的换购意愿。",
    ],
    categorySlug: "caijing",
    categoryName: "财经观察",
    author: "财经组 · 沈桥",
    time: "9 小时前",
    date: "2026-09-10T01:35:00+08:00",
    readTime: "4 分钟",
    tags: ["新能源车", "下乡", "充电设施"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20about%20electric%20vehicles%20in%20rural%20county%20areas%20and%20charging%20stations%2C%20abstract%20geometric%20shapes%2C%20flat%20vector%20style%2C%20warm%20vermillion%20red%20and%20amber%20gold%20on%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20no%20faces&width=1200&height=900&seq=news-fd-12&orientation=landscape",
    imageAlt: "县域新能源车与充电设施的概念插画",
    comments: 214,
    heat: 4380,
    isTop: false,
    isBreaking: false,
  },
  {
    id: 13,
    title: "短视频平台上线青少年模式新版本，家长可远程管理",
    excerpt:
      "多家短视频平台更新了青少年模式，新增使用时长提醒与家长远程管理功能。如何平衡保护与体验，仍是讨论的核心。",
    content: [
      "本周起，多家短视频平台的青少年模式陆续推送新版本，最大的变化是加入了家长端的管理入口，可以远程设置单日使用时长与允许浏览的内容范围。",
      "与以往需要手动切换的模式相比，新版本在首次进入时会进行更明确的提示，家长端完成绑定后，孩子端的时长和内容将同步生效，减少了「绕过模式」的空间。",
      "有家长表示，这类工具确实省心，但也担心过于严格会让孩子转向其他平台。也有用户提出，内容池的丰富度同样重要，如果可看的内容太少，模式容易形同虚设。",
      "平台方面回应称，内容池会根据反馈持续扩充，并优先收录科普、艺术与体育类内容。相关研究者建议，家长陪伴与沟通依然是不可替代的一环，工具只是辅助。",
    ],
    categorySlug: "keji",
    categoryName: "科技快讯",
    author: "科技组 · 顾言",
    time: "11 小时前",
    date: "2026-09-09T23:20:00+08:00",
    readTime: "3 分钟",
    tags: ["青少年模式", "短视频", "家长管理"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20about%20a%20safe%20teen%20mode%20on%20short%20video%20apps%20and%20parental%20control%2C%20abstract%20geometric%20shapes%2C%20flat%20vector%20style%2C%20warm%20vermillion%20red%20and%20amber%20gold%20on%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20no%20faces&width=1200&height=900&seq=news-fd-13&orientation=landscape",
    imageAlt: "短视频青少年模式与家长管理的概念插画",
    comments: 466,
    heat: 5320,
    isTop: false,
    isBreaking: false,
  },
  {
    id: 14,
    title: "城市公园 24 小时开放试点，夜间照明与安防同步升级",
    excerpt:
      "首批 24 小时开放的城市公园试点名单公布。在延长开放时间的同时，园区同步补充了照明、监控与夜间巡逻力量。",
    content: [
      "首批 24 小时开放的城市公园试点名单近日公布，覆盖多个城区。与过去定时闭园不同，这些公园将全天候开放，满足晨练和夜间散步人群的需求。",
      "延长开放时间的前提，是配套的升级。试点公园在主园路和湖区周边补充了照明设施，增加了监控点位，并安排了夜间巡逻班次。部分园区还设置了紧急求助柱，一键即可联系值班室。",
      "周边居民的反应整体积极。有夜跑爱好者表示，以前只能在马路边跑，现在多了一个安全的选择。也有居民建议，靠近住宅区的一侧需要控制音量，避免影响休息。",
      "公园管理方表示，试点期间会收集使用数据与居民反馈，再决定是否扩大范围。夜间时段的保洁和人手安排，目前仍在动态调整之中。",
    ],
    categorySlug: "shehui",
    categoryName: "社会热点",
    author: "现场组 · 陈默",
    time: "13 小时前",
    date: "2026-09-09T21:10:00+08:00",
    readTime: "3 分钟",
    tags: ["城市公园", "夜间经济", "公共服务"],
    image:
      "https://readdy.ai/api/search-image?query=Editorial%20magazine%20illustration%20about%20a%20city%20park%20open%20all%20night%20with%20warm%20lights%20and%20security%2C%20abstract%20geometric%20shapes%2C%20flat%20vector%20style%2C%20warm%20vermillion%20red%20and%20amber%20gold%20on%20cream%20paper%20background%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20no%20faces&width=1200&height=900&seq=news-fd-14&orientation=landscape",
    imageAlt: "24 小时开放城市公园夜景的概念插画",
    comments: 331,
    heat: 4890,
    isTop: false,
    isBreaking: false,
  },
];

export const heroImage =
  "https://readdy.ai/api/search-image?query=Stylized%20editorial%20newsroom%20illustration%20about%20breaking%20hot%20topics%20spreading%20across%20a%20city%2C%20abstract%20radiating%20geometric%20shapes%2C%20flat%20vector%20style%2C%20warm%20vermillion%20red%20and%20amber%20gold%20on%20deep%20ink%20background%2C%20subtle%20grain%20texture%2C%20no%20text%2C%20no%20faces&width=1600&height=900&seq=news-fd-hero&orientation=landscape";

export const quickTicker: string[] = [
  "古装剧《长夜行》收官夜热搜霸榜",
  "暴雨夜外卖订单激增，平台当日免罚",
  "国产大模型再度开源，社区连夜微调",
  "音乐节门票秒空，二手加价引热议",
  "城市公园 24 小时开放试点名单公布",
  "社区餐饮夜间订单同比上升一成",
];

export const hotSearch: string[] = [
  "长夜行收官",
  "暴雨外卖免罚",
  "开源大模型",
  "音乐节抢票",
  "剩菜盲盒",
  "折叠屏销量",
  "公园24小时开放",
  "青训报名",
];

export const trendingList: { rank: number; id: number; title: string; tag: string; heat: number }[] = [
  { rank: 1, id: 1, title: "古装剧《长夜行》收官夜热搜霸榜", tag: "娱乐爆料", heat: 9860 },
  { rank: 2, id: 3, title: "暴雨夜外卖订单激增，平台宣布当日免罚", tag: "社会热点", heat: 8610 },
  { rank: 3, id: 5, title: "国产大模型再度开源，开发者连夜跟进", tag: "科技快讯", heat: 7010 },
  { rank: 4, id: 2, title: "音乐节门票秒空，二手平台加价转卖", tag: "娱乐爆料", heat: 7320 },
  { rank: 5, id: 9, title: "联赛争冠悬念保留到最后一轮", tag: "体坛动态", heat: 6890 },
  { rank: 6, id: 8, title: "年轻人爱上「剩菜盲盒」", tag: "生活八卦", heat: 6650 },
  { rank: 7, id: 4, title: "地铁车厢手机外放被劝阻引讨论", tag: "社会热点", heat: 6240 },
  { rank: 8, id: 7, title: "露营降温？商家转做城市微度假", tag: "生活八卦", heat: 5960 },
  { rank: 9, id: 6, title: "折叠屏手机销量同比翻番", tag: "科技快讯", heat: 5480 },
  { rank: 10, id: 11, title: "小店经济回暖，夜间订单增长明显", tag: "财经观察", heat: 4760 },
];

export const liveFeed: { time: string; text: string; categorySlug: string; id: number }[] = [
  { time: "刚刚", text: "《长夜行》主创团队深夜发布长文，回应加更争议", categorySlug: "yule", id: 1 },
  { time: "6 分钟前", text: "多地外卖平台公告：恶劣天气超时订单当日免罚", categorySlug: "shehui", id: 3 },
  { time: "12 分钟前", text: "开源大模型社区出现首批本地部署实测数据", categorySlug: "keji", id: 5 },
  { time: "25 分钟前", text: "某户外音乐节宣布启动退票回流通道", categorySlug: "yule", id: 2 },
  { time: "38 分钟前", text: "联赛最后一轮争冠三队比赛改为同时开球", categorySlug: "tiyu", id: 9 },
  { time: "52 分钟前", text: "多家面包店上线「剩菜盲盒」，晚间排队明显", categorySlug: "shenghuo", id: 8 },
  { time: "1 小时前", text: "地铁运营方：外放劝阻以引导为主", categorySlug: "shehui", id: 4 },
  { time: "2 小时前", text: "折叠屏新机线下体验量明显上升", categorySlug: "keji", id: 6 },
];

export const faqs: { q: string; a: string }[] = [
  {
    q: "沸点爆料的内容多久更新一次？",
    a: "首页的实时快讯滚动条与「刚刚发生」时间线会随当日热点持续更新，通常在工作日白天保持较高频率，重要事件会在发生后第一时间跟进。",
  },
  {
    q: "网站上的爆料信息来自哪里？",
    a: "内容主要来自编辑团队的公开信息整理，以及读者通过投稿入口提交的线索。对于来源不明或无法交叉核实的信息，我们会在文中明确标注并保持谨慎。",
  },
  {
    q: "我也可以投稿爆料吗？",
    a: "可以。进入「联系我们」页面，填写爆料投递表单，尽量写清事件发生的时间、地点和可核实的线索。若涉及隐私，我们会在发布前进行必要的信息脱敏。",
  },
  {
    q: "为什么有些内容没有提到具体人物姓名？",
    a: "在信息尚未完全核实，或涉及个人隐私与名誉的情况下，我们会采用模糊化处理，只描述事件本身。这既是内容原则，也是对当事人的基本保护。",
  },
  {
    q: "热点事件的后续进展会继续更新吗？",
    a: "会。对于关注度较高的热点，我们会在原文中更新最新进展，并在详情页保留相关推荐，方便读者了解事件的完整脉络。",
  },
  {
    q: "订阅通知会发送哪些内容？",
    a: "订阅后主要接收当日热榜摘要与重大热点提醒，频率可控，不会频繁打扰。你可以随时停止接收。",
  },
];

export const siteStats: { label: string; value: string }[] = [
  { label: "每日跟进热点", value: "60+" },
  { label: "内容频道", value: "6 个" },
  { label: "读者投稿线索", value: "2.4 万条" },
  { label: "平均更新间隔", value: "20 分钟" },
];

export const contentPrinciples: { icon: string; title: string; desc: string }[] = [
  {
    icon: "ri-shield-check-line",
    title: "先核实，再发布",
    desc: "对每一条线索至少做一次交叉验证，来源不明的内容宁可慢一步，也不抢快出错。",
  },
  {
    icon: "ri-user-heart-line",
    title: "保护当事人",
    desc: "涉及隐私与未成年人的信息，一律做脱敏处理，不放大与事件无关的个人细节。",
  },
  {
    icon: "ri-links-line",
    title: "标注来源与时间",
    desc: "重要信息会写明时间线与来源，方便读者自行判断，也便于后续跟进更新。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续跟进不烂尾",
    desc: "热点不是发完就结束，后续进展会回到同一篇内容中更新，让脉络可追溯。",
  },
];

export const testimonials: { name: string; role: string; text: string }[] = [
  {
    name: "夜行列车",
    role: "通勤读者",
    text: "每天早上刷一遍热榜和快讯，基本就知道昨天夜里发生了啥，省得在好几个群里翻消息。",
  },
  {
    name: "橘子汽水",
    role: "内容爱好者",
    text: "喜欢它写事情比较克制，不会为了流量硬编细节，涉及个人隐私的地方处理得挺到位。",
  },
  {
    name: "老周不加班",
    role: "社区店主",
    text: "小店经济那个频道我常看，讲的都是身边能对上的变化，比宏观报告接地气多了。",
  },
];